import { Route, Routes } from 'react-router';
import { CallbackGimaPage } from './components';

export const CallbackRoutes = () => {
  return (
    <Routes>
      <Route path="/gima" element={<CallbackGimaPage />} />
    </Routes>
  );
};
